import { ChakraProps } from "@chakra-ui/react"
import Script from "next/script"
import { useState } from "react"
import useBimData from "../../../common/hooks/useBimData"
import { useBrandedTranslation } from "../../../common/hooks/useBrandedTranslation"
import DownloadButton from "../../shared/DownloadButton/DownloadButton"

type Props = ChakraProps & {
  productKey: string
  locale: string
}

export default function DownloadBimButton({ productKey, locale, ...rest }: Props) {
  const { isLoading: isBimFileFetchLoading, hasBimRevitFile } = useBimData(productKey, locale)
  const [bimScriptSrc, setBimScriptSrc] = useState<string>("")
  const [bimScriptLoaded, setBimScriptLoaded] = useState<boolean>(false)
  const [isBimScriptLoading, setIsBimScriptLoading] = useState<boolean>(false)
  const { t } = useBrandedTranslation()

  const bimOpenModal = () => {
    if (globalThis.showDownloadModal) {
      try {
        globalThis.showDownloadModal()
      } catch (error) {
        console.error("Error occurred while opening BIM download modal:", error)
      }
    } else {
      console.error("showDownloadModal is not defined on the global object")
    }
  }

  const onBimButtonClick = () => {
    // if the script is already loaded, just call the function
    if (bimScriptLoaded) {
      return bimOpenModal()
    }
    setIsBimScriptLoading(true)
    setBimScriptSrc(`/api/bim/catalog-script?locale=${locale}&productId=${productKey}`)
  }

  const onBimScriptLoad = () => {
    setBimScriptLoaded(true)
    setIsBimScriptLoading(false)
    bimOpenModal()
  }

  return (
    <>
      {(isBimFileFetchLoading || hasBimRevitFile) && (
        <DownloadButton
          isLoading={isBimFileFetchLoading || isBimScriptLoading}
          onClick={onBimButtonClick}
          label={t("pdp-downloadBim")}
          {...rest}
        />
      )}
      {bimScriptSrc && (
        <Script
          src={bimScriptSrc}
          strategy="afterInteractive"
          onLoad={onBimScriptLoad}
          onError={(e) => console.error("BIM Script failed", e)}
        />
      )}
    </>
  )
}
